// extracted by mini-css-extract-plugin
module.exports = {"leagueOfLegends":"style_leagueOfLegends__3oQ2q","back_share_father":"style_back_share_father__2Q_Xh","back_btn":"style_back_btn__JCFlM","share":"style_share__ApuCI"};